module.exports = __webpack_public_path__ + "static/media/5.aca13fff.jpg";